<template>
  <router-view />
</template>

<script>
export default {
  name: 'Locations',
}
</script>
